export default {
	code: 'Code',
	name: 'Vulnerability',
	catalog: 'Catalog',
	connectedRisks: 'Connected risks',
	score: 'Risk score',
	category: 'Category',
	description: 'Description',
	addName: 'Add vulnerability name',
	addCode: 'Add vulnerability code',
	addDescription: 'Add vulnerability description',
	addVulnerability: 'Add new Vulnerability',
}
